<template>
  <cms-video
    v-if="videoSetUp"
    :theme="videoOptions"
    :content="videoContent"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useMainStore } from '../../../../stores/mainStore.js';
import { useTranslationStore } from '../../../../stores/translationStore.js';
import isEmpty from 'lodash/isEmpty';

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const mainStore = useMainStore();
const translationStore = useTranslationStore();

const theme = computed(() => mainStore.theme);
const homepage = computed(() => mainStore.homepage);
const isThemePreview = computed(() => mainStore.isThemePreview);

const id = computed(() => (isThemePreview.value ? 'preview_id' : `${props.containerId}_${props.componentIdx}`));

const videoOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: translationStore.getComponentTranslation('video'),
    globalThemeSettings: mainStore.getGlobalThemeSettings,
  };
});

// The editor orders videos by `position`; render the same order here so the public homepage
// matches what was edited, including data saved before the store kept array order in sync (SO-3972).
const videoContent = computed(() => {
  const block = homepage.value.video?.[id.value];
  if (!block) return block;
  const videos = [...(block.videos || [])].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
  return { ...block, videos };
});

const videoSetUp = computed(() => {
  const videoList = videoContent.value?.videos || [];
  return !isEmpty(videoList) && videoList.some((video) => video.url);
});
</script>
